import { useEffect, useState } from "react";
import { connect } from "react-redux";

// Formik and Yup
import { useFormik } from "formik";
import * as Yup from "yup";

// Utils component
import TextError from "utils/TextError";

// Dashboard example components
import DataTable from "examples/Tables/DataTable";
import Card from "@mui/material/Card";

// Dashboard components
import MDBox from "components/MDBox";
import MDButton from "components/MDButton";
import MDCard from "components/MDCard";
import MDInput from "components/MDInput";
import MDTypography from "components/MDTypography";

// @mui material components
import { Backdrop } from "@mui/material";
import Alert from "@mui/material/Alert";
import CircularProgress from "@mui/material/CircularProgress";
import Collapse from "@mui/material/Collapse";
import Grid from "@mui/material/Grid";
import IconButton from "@mui/material/IconButton";
import Modal from "@mui/material/Modal";
import Tooltip from "@mui/material/Tooltip";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import CloseIcon from "@mui/icons-material/Close";
import Icon from "@mui/material/Icon";

import Select from "react-select";

import DownloadButton from "components/standardized-components/DownloadButton";
import DownloadDataButton from "components/standardized-components/DownloadDataButton";
import UploadButton from "components/standardized-components/UploadButton";
import { CSVLink } from "react-csv";
import { toast } from "react-toastify";

import CreateButton from "components/standardized-components/CreateButton";
import DeleteButton from "components/standardized-components/DeleteButton";
import EditButton from "components/standardized-components/EditButton";

import Footer from "examples/Footer";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";


import { CustomToastContent } from "../../examples/CustomToastContent/index";

// Store actions
import {
  createSupplierInformation,
  deleteSupplierInformation,
  editSupplierInformation,
  getAllSupplierInformation,
  getDppDocumentsImage,
  getSubModulesByRoleId,
  uploadCsvForSupplierInformation,
} from "../../store";

// Cookies
import Cookies from "universal-cookie";

const cookies = new Cookies();

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: { xs: 350, lg: 800 },
  height: "fit-content",
  maxHeight: "90%",
  boxShadow: 24,
  p: 0,
  pt: 2,
  overflow: "auto",
};

const styleForEdit = { ...style, p: 1, pt: 3 };

const deleteStyle = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 350,
  boxShadow: 24,
  p: 2,
  pt: 3,
};

const SupplierInformation = ({
  getAllSupplierReducer,
  getAllSupplierInformation,
  createSupplierInformation,
  editSupplierInformation,
  deleteSupplierInformation,
  getSubModulesByRoleId,
  getSubModulesByRoleIdReducer,
  getDppDocumentsImage,
  getDppDocumentsImageReducer,
  uploadCsvForSupplierInformation,
}) => {
  let loginDetails = cookies.get("loginDetailsForWMS");
  let jwtToken = loginDetails?.jwt;
  let userId = loginDetails?.data?.userId || "system";
  let roleId = loginDetails.data.roleId;

  useEffect(() => {
    getSubModulesByRoleId(roleId, jwtToken);
  }, [roleId]);

  const [modulesData, setModulesData] = useState([]);

  useEffect(() => {
    setModulesData(
      getSubModulesByRoleIdReducer.subModulesByRoleData.data
        ? getSubModulesByRoleIdReducer.subModulesByRoleData.data
        : [],
    );
  }, [getSubModulesByRoleIdReducer]);

  // Replace with correct UUID for Supplier Information module
  let ItemLocationMapping = modulesData.find(
    (moduleId) => moduleId.moduleId == "b3605909-30dc-4c9f-8918-f1ef34354fd2",
  );

  let allocateAccess = ItemLocationMapping
    ? ItemLocationMapping.actionId.includes(
      "434ae990-b2de-4142-9297-6df24fe43b6f",
    )
    : null;
  let viewAccess = ItemLocationMapping
    ? ItemLocationMapping.actionId.includes(
      "acf6e194-8a3f-4c7f-98b7-9cc2151ed763",
    )
    : null;
  let editAccess = ItemLocationMapping
    ? ItemLocationMapping.actionId.includes(
      "e1a9e3c5-7896-437b-8b1f-39144248fd07",
    )
    : null;
  let deleteAccess = ItemLocationMapping
    ? ItemLocationMapping.actionId.includes(
      "a3048acc-fe87-48ca-a0cd-8d815878faa3",
    )
    : null;

  const [loading, setLoading] = useState(true);

  const complianceOptions = [
    { label: "Passed", value: "Passed" },
    { label: "Failed", value: "Failed" },
    { label: "Pending", value: "Pending" },
  ];

  useEffect(() => {
    getAllSupplierInformation(jwtToken);
  }, [jwtToken]);

  const [state, setState] = useState({
    columns: [
      { Header: "Supplier ID", accessor: "supplierId" },
      { Header: "Supplier Name", accessor: "supplierName" },
      { Header: "Type", accessor: "supplierType" },
      { Header: "Score", accessor: "sustainabilityScore" },
      { Header: "rating", accessor: "rating" },
      { Header: "Compliance", accessor: "socialcomplianceStatus" },
      { Header: "Doc. Type", accessor: "documentType" },
      {
        Header: "Document",
        accessor: "file",
        cannotSearch: true,
        cannotSort: true,
      },
      {
        Header: "Action",
        accessor: "action",
        cannotSearch: true,
        cannotSort: true,
      },
    ],
    rows: [],
  });

  const { columns, rows } = state;

  const headers = [
    { label: "Supplier Name", key: "supplierName" },
    { label: "Supplier Type", key: "supplierType" },
    { label: "Sustainability Score", key: "sustainabilityScore" },
    { label: "Social Compliance Status", key: "socialComplianceStatus" },
    { label: "Rating", key: "rating" },
  ];

  const headersForTemp = [
    { label: "supplierName", key: "supplierName" },
    { label: "supplierType", key: "supplierType" },
    { label: "sustainabilityScore", key: "sustainabilityScore" },
    { label: "socialComplianceStatus", key: "socialComplianceStatus" },
    { label: "rating", key: "rating" },
  ];

  const csvExportData = (getAllSupplierReducer?.supplierList?.data || []).map(
    (item) => ({
      supplierName: item.supplierName,
      supplierType: item.supplierType,
      sustainabilityScore: item.sustainabilityScore,
      socialComplianceStatus:
        item.socialcomplianceStatus || item.socialComplianceStatus,
      rating: item.rating || "",
    }),
  );

  const csvLink = {
    filename: "Supplier Information List.csv",
    headers: headers,
    data: csvExportData,
  };

  const csvLink2 = {
    filename: "Supplier Information Upload Template.csv",
    headers: headersForTemp,
    data: [],
  };

  const [showUploadPanel, setShowUploadPanel] = useState(false);
  const [uploadCsvData, setUploadCsvData] = useState(null);

  const handleUploadClick = () => {
    setShowUploadPanel(!showUploadPanel);
    setUploadCsvData(null);
  };

  const uploadCsvHandler = async () => {
    if (!uploadCsvData) {
      toast.error("Please select a CSV file first!");
      return;
    }

    let formData = new FormData();
    formData.append("file", uploadCsvData);

    try {
      let res = await uploadCsvForSupplierInformation(formData, jwtToken);

      if (res?.status === true || res?.data?.status === true) {
        getAllSupplierInformation(jwtToken);

        setShowUploadPanel(false);
        setUploadCsvData(null);
      }

      showUploadNotification(res);
    } catch (error) {
      showUploadNotification(error);
    }
  };


  const showUploadNotification = (res) => {
    const payload = res?.response?.data || res?.data?.data || res?.data || res || {};

    const isSuccess = payload.status === true;
    const msg = payload.msg;
    const description = payload.description;

    const counts = {
      success: payload.successCount,
      error: payload.errorCount,
      duplicate: payload.duplicateCount
    };

    const toastOptions = {
      position: "top-center",
      autoClose: 5000,
      closeOnClick: false,
      draggable: true,
    };

    if (isSuccess) {
      toast.success(
        <CustomToastContent msg={msg} description={description} counts={counts} isSuccess={true} />,
        toastOptions
      );
    } else {
      toast.error(
        <CustomToastContent msg={msg} description={description} counts={counts} isSuccess={false} />,
        toastOptions
      );
    }
  };

  const [currentFile, setCurrentFile] = useState(null);

  const handleOpenDocument = (item) => {
    const moduleName = item.moduleName || "supplierinformation";
    getDppDocumentsImage(moduleName, item.type, item.name, jwtToken);
  };

  // Watch reducer for updates
  useEffect(() => {
    const data = getDppDocumentsImageReducer?.documents?.data;

    if (data) {
      setCurrentFile(data);

      getDppDocumentsImageReducer.documents.data = null;
    }
  }, [getDppDocumentsImageReducer?.documents?.data]);

  useEffect(() => {
    if (currentFile) {
      const timer = setTimeout(() => setCurrentFile(null), 1000);
      return () => clearTimeout(timer);
    }
  }, [currentFile]);

  useEffect(() => {
    if (!currentFile) return;

    let fileUrl;
    if (typeof currentFile === "string") fileUrl = currentFile;
    else if (currentFile.url) fileUrl = currentFile.url;
    else if (currentFile.base64) {
      const byteCharacters = atob(currentFile.base64);
      const byteNumbers = new Array(byteCharacters.length);
      for (let i = 0; i < byteCharacters.length; i++) {
        byteNumbers[i] = byteCharacters.charCodeAt(i);
      }
      const byteArray = new Uint8Array(byteNumbers);
      const blob = new Blob([byteArray], {
        type: currentFile.type || "application/octet-stream",
      });
      fileUrl = URL.createObjectURL(blob);
    } else return;

    window.open(fileUrl, "_blank", "noopener,noreferrer");
  }, [currentFile]);

  useEffect(() => {
    let tempMappedActivity = [];
    let data = getAllSupplierReducer?.supplierList?.data
      ? getAllSupplierReducer.supplierList.data
      : [];

    setLoading(getAllSupplierReducer?.loading || false);

    [...data].reverse().map((item) => {
      const itemObject = {
        supplierId: item.supplierId,
        supplierName: item.supplierName,
        supplierType: item.supplierType,
        sustainabilityScore: item.sustainabilityScore,
        rating: item.rating,
        socialcomplianceStatus: item.socialcomplianceStatus,
        documentType: item.documentType,

        file: item.name ? (
          <MDButton
            variant="gradient"
            color="info"
            iconOnly
            disabled={item.moduleName==null}
            size="small"
            style={{ padding: "4px", minWidth: "32px" }}
            onClick={() => handleOpenDocument(item)}
            title={item.name}
          >
            <Icon>description</Icon>
          </MDButton>
        ) : (
          "-"
        ),

        action: (
          <>
            {deleteAccess && (
              <DeleteButton
                tooltip="Delete"
                variant="gradient"
                color="error"
                iconOnly
                type="button"
                style={{ marginRight: "5px" }}
                onClick={() => handleOpenDeleteModal(item)}
              >
                <Icon>delete</Icon>
              </DeleteButton>
            )}

            {editAccess && (
              <EditButton
                tooltip="Edit"
                variant="gradient"
                color="success"
                iconOnly
                type="button"
                onClick={() => handleOpenUpdateModal(item)}
                style={{ marginRight: "5px" }}
              >
                <Icon>edit_sharp</Icon>
              </EditButton>
            )}
          </>
        ),
      };
      tempMappedActivity.push(itemObject);
    });

    setState((prevState) => ({ ...prevState, rows: tempMappedActivity }));
  }, [getAllSupplierReducer]);

  const [openCreateModal, setOpenCreateModal] = useState(false);
  const [isSuccessCreate, setIsSuccessCreate] = useState(false);
  const [isErrorCreate, setIsErrorCreate] = useState(false);
  const [errorMsgCreate, setErrorMsgCreate] = useState("");
  const [createButtonName, setCreateButtonName] = useState("Create");

  const handleOpenCreateModal = () => {
    setOpenCreateModal(true);
    formik.setErrors({});
  };

  const handleCloseCreateModal = (event, reason) => {
    if (reason === "backdropClick") return;
    setOpenCreateModal(false);
    formik.resetForm();
  };

  useEffect(() => {
    if (isSuccessCreate) setTimeout(() => setIsSuccessCreate(false), 3000);
    if (isErrorCreate) setTimeout(() => setIsErrorCreate(false), 3000);
  }, [isSuccessCreate, isErrorCreate]);

  const initialValues = {
    supplierName: "",
    rating: "",
    supplierType: "",
    sustainabilityScore: "",
    socialcomplianceStatus: "",
    file: null, // Used for file upload
  };

  const validationSchema = Yup.object({
    supplierName: Yup.string().required("   "),
    rating: Yup.string().required("   "),
    supplierType: Yup.string().required("   "),
    sustainabilityScore: Yup.string().required("   "),
    socialcomplianceStatus: Yup.object().required("   "),
    file: Yup.mixed().required(" "),
  });

  const onSubmit = async (values, { resetForm }) => {
    setCreateButtonName("Please wait...");

    const formData = new FormData();
    formData.append("supplierName", values.supplierName);
    formData.append("supplierType", values.supplierType);
    formData.append("sustainabilityScore", values.sustainabilityScore);
    formData.append(
      "socialcomplianceStatus",
      values.socialcomplianceStatus?.value,
    );
    formData.append("cdBy", userId);
    formData.append("moduleName", "supplier information");
    formData.append("documentType", "certificate");
    formData.append("rating", values.rating);


    if (values.file) {
      formData.append("attachments", values.file);
    }

    let res = await createSupplierInformation(formData, jwtToken);

    if (res.status) {
      setIsSuccessCreate(true);
      getAllSupplierInformation(jwtToken);
      setTimeout(() => {
        setCreateButtonName("Create");
        handleCloseCreateModal();
      }, 2000);
    } else {
      setErrorMsgCreate(res?.data?.msg || "Something went wrong");
      setIsErrorCreate(true);
      setCreateButtonName("Create");
    }
  };

  const formik = useFormik({
    initialValues,
    validationSchema,
    onSubmit,
  });

  const [openUpdateModal, setOpenUpdateModal] = useState(false);
  const [singleDataForUpdate, setSingleDataForUpdate] = useState({});
  const [isSuccessForUpdate, setIsSuccessForUpdate] = useState(false);
  const [isErrorForUpdate, setIsErrorForUpdate] = useState(false);
  const [errorMsgForUpdate, setErrorMsgForUpdate] = useState("");
  const [editButtonName, setEditButtonName] = useState("Update");

  const handleOpenUpdateModal = (data) => {
    setSingleDataForUpdate(data);
    setOpenUpdateModal(true);
  };

  const handleCloseUpdateModal = (event, reason) => {
    if (reason === "backdropClick") return;
    setOpenUpdateModal(false);
    formikForUpdate.resetForm();
  };

  useEffect(() => {
    if (isSuccessForUpdate)
      setTimeout(() => setIsSuccessForUpdate(false), 3000);
    if (isErrorForUpdate) setTimeout(() => setIsErrorForUpdate(false), 3000);
  }, [isSuccessForUpdate, isErrorForUpdate]);

  const defaultCompliance = complianceOptions.find(
    (opt) => opt.value === singleDataForUpdate.socialcomplianceStatus,
  );

  const initialValueForUpdate = {
    supplierId: singleDataForUpdate.supplierId || "",
    supplierName: singleDataForUpdate.supplierName || "",
    supplierType: singleDataForUpdate.supplierType || "",
    sustainabilityScore: singleDataForUpdate.sustainabilityScore || "",
    rating: singleDataForUpdate.rating || "",
    socialcomplianceStatus: defaultCompliance || "",
    file: null,
  };

  const validationSchemaEdit = Yup.object({
    supplierName: Yup.string().required("   "),
    rating: Yup.string().required("   "),
    supplierType: Yup.string().required("   "),
    sustainabilityScore: Yup.string().required("   "),
    socialcomplianceStatus: Yup.object().required("   "),
  });

  const onSubmitForUpdate = async (values) => {
    setEditButtonName("Please wait...");

    const formData = new FormData();
    formData.append("supplierId", values.supplierId);
    formData.append("supplierName", values.supplierName);
    formData.append("supplierType", values.supplierType);
    formData.append("sustainabilityScore", values.sustainabilityScore);
    formData.append(
      "socialcomplianceStatus",
      values.socialcomplianceStatus?.value,
    );
    formData.append("udBy", userId);
    formData.append("moduleName", "supplier information");
    formData.append("documentType", "certificate");
    formData.append("rating", values.rating);

    if (values.file) {
      formData.append("attachments", values.file);
    }

    let res = await editSupplierInformation(formData, jwtToken);

    if (res.status) {
      setIsSuccessForUpdate(true);
      getAllSupplierInformation(jwtToken);
      setTimeout(() => {
        handleCloseUpdateModal();
        setEditButtonName("Update");
      }, 2000);
    } else {
      setIsErrorForUpdate(true);
      setErrorMsgForUpdate(res?.data?.msg || "Failed to update");
      setEditButtonName("Update");
    }
  };

  const formikForUpdate = useFormik({
    initialValues: initialValueForUpdate,
    validationSchema: validationSchemaEdit,
    onSubmit: onSubmitForUpdate,
    enableReinitialize: true,
  });

  const [openDeleteModal, setOpenDeleteModal] = useState(false);
  const [singleDataForDelete, setSingleDataForDelete] = useState({});
  const [isSuccessForDelete, setIsSuccessForDelete] = useState(false);
  const [isErrorForDelete, setIsErrorForDelete] = useState(false);
  const [errorMsgForDelete, setErrorMsgForDelete] = useState("");
  const [deleteButtonName, setDeleteButtonName] = useState("Delete");

  const handleOpenDeleteModal = (data) => {
    setSingleDataForDelete(data);
    setOpenDeleteModal(true);
  };

  const handleCloseDeleteModal = () => {
    setOpenDeleteModal(false);
  };

  useEffect(() => {
    if (isSuccessForDelete)
      setTimeout(() => setIsSuccessForDelete(false), 2000);
    if (isErrorForDelete) setTimeout(() => setIsErrorForDelete(false), 3000);
  }, [isSuccessForDelete, isErrorForDelete]);

  const deleteRecord = async () => {
    setDeleteButtonName("Please wait...");
    let id = singleDataForDelete.supplierId;
    let udBy = userId;

    let res = await deleteSupplierInformation(id, udBy, jwtToken);

    if (res.status) {
      setIsSuccessForDelete(true);
      getAllSupplierInformation(jwtToken);
      setTimeout(() => {
        handleCloseDeleteModal();
        setDeleteButtonName("Delete");
      }, 2000);
    } else {
      setIsErrorForDelete(true);
      setErrorMsgForDelete(res?.data?.msg || "Failed to delete");
      setDeleteButtonName("Delete");
    }
  };

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox pt={0} pb={3} mb={-2.5}>
        <Grid container spacing={6}>
          <Grid item xs={12}>
            <Card>

              <MDBox color="text" p={0} px={2} mt={1} mb={1}>
                {allocateAccess && (
                  <MDBox display="flex" alignItems="center">
                    <Tooltip title="Create Supplier Information">
                      <CreateButton
                        tooltip="Add Supplier Information"
                        color="info"
                        variant="contained"
                        type="button"
                        iconOnly
                        onClick={handleOpenCreateModal}
                        style={{ borderRadius: "5px" }}
                        size="small"
                      >
                        <Icon>add</Icon>
                      </CreateButton>
                    </Tooltip>

                    <CSVLink {...csvLink}>
                      <DownloadDataButton
                        tooltip="Download Supplier Information List"
                        style={{ marginLeft: "1rem" }}
                        type="button"
                        variant="outlined"
                        color="error"
                        iconOnly
                      >
                        <Icon>download</Icon>
                      </DownloadDataButton>
                    </CSVLink>

                    <UploadButton
                      tooltip="Upload CSV"
                      style={{ marginLeft: "1rem", marginTop: "4px" }}
                      type="button"
                      variant={showUploadPanel ? "contained" : "outlined"}
                      color="info"
                      iconOnly
                      onClick={handleUploadClick}
                    >
                      <Icon>upload</Icon>
                    </UploadButton>

                    <CSVLink {...csvLink2}>
                      <DownloadButton
                        tooltip="Download Template"
                        style={{ marginLeft: "1rem" }}
                        type="button"
                        variant="outlined"
                        color="error"
                        iconOnly
                      >
                        <Icon>description</Icon>
                      </DownloadButton>
                    </CSVLink>

                    {showUploadPanel && (
                      <MDBox
                        display="flex"
                        alignItems="center"
                        ml={2}
                        p={0.5}
                        px={2}
                      >
                        <input
                          className="choose_file"
                          type="file"
                          accept=".csv"
                          onChange={(e) =>
                            setUploadCsvData(e.target.files[0])
                          }
                          style={{ width: "200px" }}
                        />

                        <MDButton
                          disabled={
                            !uploadCsvData?.name ||
                            uploadCsvData?.type !== "text/csv"
                          }
                          variant="contained"
                          color="info"
                          style={{ marginLeft: "1rem" }}
                          onClick={uploadCsvHandler}
                        >
                          UPLOAD
                        </MDButton>

                        <IconButton
                          size="small"
                          onClick={() => setShowUploadPanel(false)}
                          style={{ marginLeft: "10px", color: "gray" }}
                        >
                          <CloseIcon fontSize="small" />
                        </IconButton>
                      </MDBox>
                    )}
                  </MDBox>
                )}
              </MDBox>



              {/* DataTable */}
              <MDBox pt={0}>
                <DataTable
                  table={{ columns, rows }}
                  isSorted={true}
                  tableSearch={true}
                  entriesPerPage={{
                    defaultValue: 5,
                    entries: [5, 10, 15, 20, 25],
                  }}
                  showTotalEntries={true}
                  noEndBorder
                />
              </MDBox>

              {/* CREATE MODAL */}
              <Modal open={openCreateModal} onClose={handleCloseCreateModal}>
                <MDCard sx={style}>
                  <MDBox ml={3} mt={-1} display="flex" alignItems="center">
                    <MDTypography
                      variant="h5"
                      fontWeight="medium"
                      flexGrow={1}
                    >
                      Create Supplier Information
                    </MDTypography>
                    <Tooltip title="Close">
                      <IconButton
                        style={{
                          background: "whitesmoke",
                          color: "black",
                          borderRadius: 5,
                          marginRight: "10px",
                          marginTop: "4px",
                        }}
                        onClick={handleCloseCreateModal}
                      >
                        <CloseIcon />
                      </IconButton>
                    </Tooltip>
                  </MDBox>
                  <hr style={{ marginTop: "0.5rem", marginBottom: "1rem" }} />

                  <MDBox pt={1} pb={3} px={3}>
                    <MDBox
                      component="form"
                      role="form"
                      onSubmit={formik.handleSubmit}
                    >
                      <Grid container spacing={2}>
                        {/* Supplier Name */}
                        <Grid item xs={12} lg={4}>
                          <MDBox>
                            <MDTypography variant="h6">
                              Supplier Name
                            </MDTypography>
                            <MDInput
                              size="small"
                              type="text"
                              name="supplierName"
                              fullWidth
                              autoComplete="off"
                              value={formik.values.supplierName}
                              onChange={formik.handleChange}
                              onBlur={formik.handleBlur}
                              error={
                                formik.touched.supplierName &&
                                Boolean(formik.errors.supplierName)
                              }
                            />
                            {formik.touched.supplierName &&
                              formik.errors.supplierName && (
                                <TextError msg={formik.errors.supplierName} />
                              )}
                          </MDBox>
                        </Grid>

                        {/* Supplier Type */}
                        <Grid item xs={12} lg={4}>
                          <MDBox ml={1}>
                            <MDTypography variant="h6">
                              Supplier Type
                            </MDTypography>
                            <MDInput
                              size="small"
                              type="text"
                              name="supplierType"
                              fullWidth
                              autoComplete="off"
                              value={formik.values.supplierType}
                              onChange={formik.handleChange}
                              onBlur={formik.handleBlur}
                              error={
                                formik.touched.supplierType &&
                                Boolean(formik.errors.supplierType)
                              }
                            />
                            {formik.touched.supplierType &&
                              formik.errors.supplierType && (
                                <TextError msg={formik.errors.supplierType} />
                              )}
                          </MDBox>
                        </Grid>

                        {/* Sustainability Score */}
                        <Grid item xs={12} lg={4}>
                          <MDBox>
                            <MDTypography variant="h6">
                              Sustainability Score
                            </MDTypography>
                            <MDInput
                              size="small"
                              type="text"
                              name="sustainabilityScore"
                              fullWidth
                              autoComplete="off"
                              value={formik.values.sustainabilityScore}
                              onChange={formik.handleChange}
                              onBlur={formik.handleBlur}
                              error={
                                formik.touched.sustainabilityScore &&
                                Boolean(formik.errors.sustainabilityScore)
                              }
                            />
                            {formik.touched.sustainabilityScore &&
                              formik.errors.sustainabilityScore && (
                                <TextError
                                  msg={formik.errors.sustainabilityScore}
                                />
                              )}
                          </MDBox>
                        </Grid>


                        <Grid item xs={12} lg={4}>
                          <MDBox>
                            <MDTypography variant="h6">
                              Rating
                            </MDTypography>
                            <MDInput
                              size="small"
                              type="text"
                              name="rating"
                              fullWidth
                              autoComplete="off"
                              value={formik.values.rating}
                              onChange={formik.handleChange}
                              onBlur={formik.handleBlur}
                              error={
                                formik.touched.rating &&
                                Boolean(formik.errors.rating)
                              }
                            />
                            {formik.touched.rating &&
                              formik.errors.rating && (
                                <TextError
                                  msg={formik.errors.rating}
                                />
                              )}
                          </MDBox>
                        </Grid>

                        {/* Social Compliance Status */}
                        <Grid item xs={12} lg={4}>
                          <MDBox ml={1}>
                            <MDTypography variant="h6">
                              Social Compliance Status
                            </MDTypography>
                            <Select
                              className="select-css"
                              placeholder="Choose one..."
                              name="socialcomplianceStatus"
                              value={formik.values.socialcomplianceStatus}
                              options={complianceOptions}
                              onBlur={() =>
                                formik.handleBlur({
                                  target: { name: "socialcomplianceStatus" },
                                })
                              }
                              onChange={(selectedOption) =>
                                formik.setFieldValue(
                                  "socialcomplianceStatus",
                                  selectedOption,
                                )
                              }
                              menuPortalTarget={document.body}
                              styles={{
                                menuPortal: (base) => ({
                                  ...base,
                                  zIndex: 9999,
                                }),
                              }}
                            />
                            {formik.touched.socialcomplianceStatus &&
                              formik.errors.socialcomplianceStatus && (
                                <TextError
                                  msg={formik.errors.socialcomplianceStatus}
                                />
                              )}
                          </MDBox>
                        </Grid>

                        <Grid item xs={4}>
                          <MDBox ml={1} mb={1}>
                            <MDTypography
                              variant="h6"
                              fontWeight={500}
                              mb={0}
                            >
                              Upload Attachment
                            </MDTypography>

                            <MDBox width="100%">
                              <input
                                id="upload-file-create"
                                type="file"
                                hidden
                                accept=".jpg,.jpeg,.png,.gif,.webp,.svg,.bmp,.tiff,.pdf"
                                onChange={(e) => {
                                  const file = e.currentTarget.files[0];
                                  if (!file) return;

                                  formik.setFieldValue("file", file);
                                  e.target.value = "";
                                }}
                              />

                              {!formik.values.file ? (
                                <label
                                  htmlFor="upload-file-create"
                                  style={{ display: "block", width: "100%" }}
                                >
                                  <MDButton
                                    variant="outlined"
                                    component="span"
                                    color="info"
                                    fullWidth
                                    sx={{
                                      height: "34px",
                                      minHeight: "34px",
                                      maxHeight: "34px",
                                      padding: "4px 16px",
                                      boxSizing: "border-box",
                                      fontSize: "0.85rem",
                                    }}
                                  >
                                    Choose File
                                  </MDButton>
                                </label>
                              ) : (
                                <label
                                  htmlFor="upload-file-create"
                                  style={{
                                    width: "100%",
                                    cursor: "pointer",
                                    display: "block",
                                  }}
                                >
                                  <MDBox
                                    display="flex"
                                    justifyContent="space-between"
                                    alignItems="center"
                                    px={1.5}
                                    sx={{
                                      height: "32.5px",
                                      border: "1px dashed #1A73E8",
                                      borderRadius: "8px",
                                      backgroundColor: "#fff",
                                      boxSizing: "border-box",
                                      transition: "background-color 0.2s",
                                      "&:hover": {
                                        backgroundColor: "#f8f9fa",
                                      },
                                    }}
                                  >
                                    <MDTypography
                                      variant="body2"
                                      color="text"
                                      sx={{
                                        whiteSpace: "nowrap",
                                        overflow: "hidden",
                                        textOverflow: "ellipsis",
                                        flex: 1,
                                        fontSize: "14px",
                                        mr: 1,
                                      }}
                                      title={formik.values.file?.name}
                                    >
                                      {formik.values.file?.name}
                                    </MDTypography>
                                    <Icon fontSize="small" color="info">
                                      edit
                                    </Icon>
                                  </MDBox>
                                </label>
                              )}
                            </MDBox>

                            {formik.touched.file && formik.errors.file && (
                              <TextError msg={formik.errors.file} />
                            )}
                          </MDBox>
                        </Grid>

                        <Grid item xs={12}>
                          <Collapse in={isErrorCreate}>
                            <Alert
                              severity="error"
                              action={
                                <IconButton
                                  size="small"
                                  onClick={() => setIsErrorCreate(false)}
                                >
                                  <CloseIcon fontSize="inherit" />
                                </IconButton>
                              }
                            >
                              {errorMsgCreate}
                            </Alert>
                          </Collapse>
                          <Collapse in={isSuccessCreate}>
                            <Alert
                              severity="success"
                              action={
                                <IconButton
                                  size="small"
                                  onClick={() => setIsSuccessCreate(false)}
                                >
                                  <CloseIcon fontSize="inherit" />
                                </IconButton>
                              }
                            >
                              Created Successfully
                            </Alert>
                          </Collapse>
                          <MDBox mt={2}>
                            <MDButton
                              color="info"
                              type="submit"
                              fullWidth
                              disabled={createButtonName === "Please wait..."}
                            >
                              {createButtonName}
                            </MDButton>
                          </MDBox>
                        </Grid>
                      </Grid>
                    </MDBox>
                  </MDBox>
                </MDCard>
              </Modal>

              {/* UPDATE MODAL */}
              <Modal open={openUpdateModal} onClose={handleCloseUpdateModal}>
                <MDCard sx={styleForEdit}>
                  <MDBox ml={3} mt={-1} display="flex" alignItems="center">
                    <MDTypography
                      variant="h4"
                      fontWeight="medium"
                      flexGrow={1}
                    >
                      Update Supplier Information
                    </MDTypography>
                    <Tooltip title="Close">
                      <IconButton
                        style={{
                          background: "whitesmoke",
                          color: "black",
                          borderRadius: 5,
                          marginRight: "10px",
                          marginTop: "4px",
                        }}
                        onClick={handleCloseUpdateModal}
                      >
                        <CloseIcon />
                      </IconButton>
                    </Tooltip>
                  </MDBox>
                  <hr style={{ marginTop: "0.5rem", marginBottom: "1rem" }} />

                  <MDBox pt={1} pb={3} px={3}>
                    <MDBox
                      component="form"
                      role="form"
                      onSubmit={formikForUpdate.handleSubmit}
                    >
                      <Grid container spacing={2}>
                        {/* Readonly Supplier ID */}
                        <Grid item xs={12} lg={4}>
                          <MDBox ml={1}>
                            <MDTypography variant="h6">
                              Supplier ID{" "}
                            </MDTypography>
                            <MDInput
                              size="small"
                              type="text"
                              name="supplierId"
                              fullWidth
                              disabled={true}
                              value={formikForUpdate.values.supplierId}
                            />
                          </MDBox>
                        </Grid>

                        {/* Supplier Name */}
                        <Grid item xs={12} lg={4}>
                          <MDBox ml={1}>
                            <MDTypography variant="h6">
                              Supplier Name
                            </MDTypography>
                            <MDInput
                              size="small"
                              type="text"
                              name="supplierName"
                              fullWidth
                              autoComplete="off"
                              value={formikForUpdate.values.supplierName}
                              onChange={formikForUpdate.handleChange}
                              onBlur={formikForUpdate.handleBlur}
                              error={
                                formikForUpdate.touched.supplierName &&
                                Boolean(formikForUpdate.errors.supplierName)
                              }
                            />
                            {formikForUpdate.touched.supplierName &&
                              formikForUpdate.errors.supplierName && (
                                <TextError
                                  msg={formikForUpdate.errors.supplierName}
                                />
                              )}
                          </MDBox>
                        </Grid>

                        {/* Supplier Type */}
                        <Grid item xs={12} lg={4}>
                          <MDBox ml={1}>
                            <MDTypography variant="h6">
                              Supplier Type
                            </MDTypography>
                            <MDInput
                              size="small"
                              type="text"
                              name="supplierType"
                              fullWidth
                              autoComplete="off"
                              value={formikForUpdate.values.supplierType}
                              onChange={formikForUpdate.handleChange}
                              onBlur={formikForUpdate.handleBlur}
                              error={
                                formikForUpdate.touched.supplierType &&
                                Boolean(formikForUpdate.errors.supplierType)
                              }
                            />
                            {formikForUpdate.touched.supplierType &&
                              formikForUpdate.errors.supplierType && (
                                <TextError
                                  msg={formikForUpdate.errors.supplierType}
                                />
                              )}
                          </MDBox>
                        </Grid>

                        {/* Sustainability Score */}
                        <Grid item xs={12} lg={4}>
                          <MDBox ml={1}>
                            <MDTypography variant="h6">
                              Sustainability Score
                            </MDTypography>
                            <MDInput
                              size="small"
                              type="text"
                              name="sustainabilityScore"
                              fullWidth
                              autoComplete="off"
                              value={
                                formikForUpdate.values.sustainabilityScore
                              }
                              onChange={formikForUpdate.handleChange}
                              onBlur={formikForUpdate.handleBlur}
                              error={
                                formikForUpdate.touched.sustainabilityScore &&
                                Boolean(
                                  formikForUpdate.errors.sustainabilityScore,
                                )
                              }
                            />
                            {formikForUpdate.touched.sustainabilityScore &&
                              formikForUpdate.errors.sustainabilityScore && (
                                <TextError
                                  msg={
                                    formikForUpdate.errors.sustainabilityScore
                                  }
                                />
                              )}
                          </MDBox>
                        </Grid>


                        <Grid item xs={12} lg={4}>
                          <MDBox ml={1}>
                            <MDTypography variant="h6">
                              Rating
                            </MDTypography>
                            <MDInput
                              size="small"
                              type="text"
                              name="rating"
                              fullWidth
                              autoComplete="off"
                              value={
                                formikForUpdate.values.rating
                              }
                              onChange={formikForUpdate.handleChange}
                              onBlur={formikForUpdate.handleBlur}
                              error={
                                formikForUpdate.touched.rating &&
                                Boolean(
                                  formikForUpdate.errors.rating,
                                )
                              }
                            />
                            {formikForUpdate.touched.rating &&
                              formikForUpdate.errors.rating && (
                                <TextError
                                  msg={
                                    formikForUpdate.errors.rating
                                  }
                                />
                              )}
                          </MDBox>
                        </Grid>

                        {/* Social Compliance Status */}
                        <Grid item xs={12} lg={4}>
                          <MDBox ml={1}>
                            <MDTypography variant="h6">
                              Social Compliance Status
                            </MDTypography>
                            <Select
                              className="select-css"
                              placeholder="Choose one..."
                              name="socialcomplianceStatus"
                              value={
                                formikForUpdate.values.socialcomplianceStatus
                              }
                              options={complianceOptions}
                              onBlur={() =>
                                formikForUpdate.handleBlur({
                                  target: { name: "socialcomplianceStatus" },
                                })
                              }
                              onChange={(selectedOption) =>
                                formikForUpdate.setFieldValue(
                                  "socialcomplianceStatus",
                                  selectedOption,
                                )
                              }
                              menuPortalTarget={document.body}
                              styles={{
                                menuPortal: (base) => ({
                                  ...base,
                                  zIndex: 9999,
                                }),
                              }}
                            />
                            {formikForUpdate.touched.socialcomplianceStatus &&
                              formikForUpdate.errors
                                .socialcomplianceStatus && (
                                <TextError
                                  msg={
                                    formikForUpdate.errors
                                      .socialcomplianceStatus
                                  }
                                />
                              )}
                          </MDBox>
                        </Grid>

                        {/* File Upload UI */}
                        {/* <Grid item xs={12}>
                        <MDBox mb={1} ml={1}>
                          <MDTypography variant="h6" fontWeight={500}>
                            Upload New Attachment (Optional)
                          </MDTypography>
                          <MDBox
                            display="flex"
                            alignItems="center"
                            width="100%"
                            gap={1}
                          >
                            <input
                              id="upload-file-update"
                              type="file"
                              hidden
                              onChange={(e) => {
                                const file = e.currentTarget.files[0];
                                formikForUpdate.setFieldValue("file", file);
                              }}
                            />
                            <label htmlFor="upload-file-update">
                              <MDButton
                                variant="outlined"
                                component="span"
                                color="info"
                              >
                                Choose File
                              </MDButton>
                            </label>
                            <MDBox
                              flex={1}
                              px={2}
                              py={1}
                              sx={{
                                border: "1px solid #e0e0e0",
                                borderRadius: "8px",
                                backgroundColor: "#fafafa",
                              }}
                            >
                              <MDTypography
                                variant="body2"
                                sx={{
                                  whiteSpace: "nowrap",
                                  overflow: "hidden",
                                  textOverflow: "ellipsis",
                                }}
                                title={formikForUpdate.values.file?.name}
                              >
                                {
                                  formikForUpdate.values.file?.name ??
                                  singleDataForUpdate?.name ??
                                  "Not Available"
                                }
                              </MDTypography>
                            </MDBox>
                          </MDBox>
                          {formikForUpdate.touched.file && formikForUpdate.errors.file && (
                            <TextError msg={formikForUpdate.errors.file} />
                          )}
                        </MDBox>
                      </Grid> */}

                        <Grid item xs={12}>
                          <MDBox ml={1} mb={1}>
                            <MDTypography
                              variant="h6"
                              fontWeight={500}
                              mb={0}
                            >
                              Upload New Attachment (Optional)
                            </MDTypography>

                            <MDBox width="100%">
                              {/* Hidden file input */}
                              <input
                                id="upload-file-update"
                                type="file"
                                hidden
                                accept=".jpg,.jpeg,.png,.gif,.webp,.svg,.bmp,.tiff,.pdf"
                                onChange={(e) => {
                                  const file = e.currentTarget.files[0];
                                  if (!file) return;

                                  formikForUpdate.setFieldValue("file", file);
                                  e.target.value = ""; // Reset target value so the same file can be re-selected if needed
                                }}
                              />

                              {/* Condition: Show Button if no file is selected AND no existing file is present */}
                              {!(
                                formikForUpdate.values.file ||
                                singleDataForUpdate?.name
                              ) ? (
                                <label
                                  htmlFor="upload-file-update"
                                  style={{
                                    display: "block",
                                    width: "100%",
                                    marginTop: "6px",
                                  }}
                                >
                                  <MDButton
                                    variant="outlined"
                                    component="span"
                                    color="info"
                                    fullWidth
                                    sx={{
                                      height: "34px",
                                      minHeight: "34px",
                                      maxHeight: "34px",
                                      padding: "4px 16px",
                                      boxSizing: "border-box",
                                      fontSize: "0.85rem",
                                    }}
                                  >
                                    Choose File
                                  </MDButton>
                                </label>
                              ) : (
                                /* Condition: Show Dashed Box with File Name and Edit Icon if file exists */
                                <label
                                  htmlFor="upload-file-update"
                                  style={{
                                    width: "100%",
                                    cursor: "pointer",
                                    display: "block",
                                    marginTop: "6px",
                                  }}
                                >
                                  <MDBox
                                    display="flex"
                                    justifyContent="space-between"
                                    alignItems="center"
                                    px={1.5}
                                    sx={{
                                      height: "32.5px",
                                      border: "1px dashed #1A73E8",
                                      borderRadius: "8px",
                                      backgroundColor: "#fff",
                                      boxSizing: "border-box",
                                      transition: "background-color 0.2s",
                                      "&:hover": {
                                        backgroundColor: "#f8f9fa",
                                      },
                                    }}
                                  >
                                    <MDTypography
                                      variant="body2"
                                      color="text"
                                      sx={{
                                        whiteSpace: "nowrap",
                                        overflow: "hidden",
                                        textOverflow: "ellipsis",
                                        flex: 1,
                                        fontSize: "14px",
                                        mr: 1,
                                      }}
                                      title={
                                        formikForUpdate.values.file?.name ||
                                        singleDataForUpdate?.name
                                      }
                                    >
                                      {formikForUpdate.values.file?.name ||
                                        singleDataForUpdate?.name}
                                    </MDTypography>
                                    <Icon fontSize="small" color="info">
                                      edit
                                    </Icon>
                                  </MDBox>
                                </label>
                              )}
                            </MDBox>

                            {/* Error Display */}
                            {formikForUpdate.touched.file &&
                              formikForUpdate.errors.file && (
                                <MDTypography
                                  variant="caption"
                                  color="error"
                                  mt={0.5}
                                  display="block"
                                >
                                  {formikForUpdate.errors.file}
                                </MDTypography>
                              )}
                          </MDBox>
                        </Grid>

                        <Grid item xs={12}>
                          <Collapse in={isErrorForUpdate}>
                            <Alert
                              severity="error"
                              action={
                                <IconButton
                                  size="small"
                                  onClick={() => setIsErrorForUpdate(false)}
                                >
                                  <CloseIcon fontSize="inherit" />
                                </IconButton>
                              }
                            >
                              {errorMsgForUpdate}
                            </Alert>
                          </Collapse>
                          <Collapse in={isSuccessForUpdate}>
                            <Alert
                              severity="success"
                              action={
                                <IconButton
                                  size="small"
                                  onClick={() => setIsSuccessForUpdate(false)}
                                >
                                  <CloseIcon fontSize="inherit" />
                                </IconButton>
                              }
                            >
                              Updated successfully
                            </Alert>
                          </Collapse>
                          <MDBox mt={2}>
                            <MDButton
                              color="info"
                              type="submit"
                              fullWidth
                              disabled={editButtonName === "Please wait..."}
                            >
                              {editButtonName}
                            </MDButton>
                          </MDBox>
                        </Grid>
                      </Grid>
                    </MDBox>
                  </MDBox>
                </MDCard>
              </Modal>

              {/* DELETE MODAL */}
              <Modal open={openDeleteModal} onClose={handleCloseDeleteModal}>
                <MDCard sx={deleteStyle}>
                  <MDTypography>
                    Are you sure you want to delete?
                  </MDTypography>
                  <MDBox mt={2} display="flex" justifyContent="space-between">
                    <MDButton
                      color="info"
                      variant="outlined"
                      onClick={handleCloseDeleteModal}
                    >
                      Cancel
                    </MDButton>
                    <MDButton
                      color="error"
                      onClick={deleteRecord}
                      disabled={deleteButtonName === "Please wait..."}
                    >
                      {deleteButtonName}
                    </MDButton>
                  </MDBox>
                  <MDBox mt={2}>
                    <Collapse in={isErrorForDelete}>
                      <Alert
                        severity="error"
                        action={
                          <IconButton
                            size="small"
                            onClick={() => setIsErrorForDelete(false)}
                          >
                            <CloseIcon fontSize="inherit" />
                          </IconButton>
                        }
                      >
                        {errorMsgForDelete}
                      </Alert>
                    </Collapse>
                    <Collapse in={isSuccessForDelete}>
                      <Alert
                        severity="success"
                        action={
                          <IconButton
                            size="small"
                            onClick={() => setIsSuccessForDelete(false)}
                          >
                            <CloseIcon fontSize="inherit" />
                          </IconButton>
                        }
                      >
                        Deleted Successfully
                      </Alert>
                    </Collapse>
                  </MDBox>
                </MDCard>
              </Modal>


            </Card>

          </Grid>

        </Grid>

      </MDBox>

      {loading && (
        <Backdrop
          sx={{ color: "blue", zIndex: (theme) => theme.zIndex.drawer + 1 }}
          open
        >
          <CircularProgress color="inherit" />
        </Backdrop>
      )}
      <ToastContainer />


      <Footer />
    </DashboardLayout>
  );
};

// Redux mapping
const mapStateToProps = (state) => ({
  getAllSupplierReducer: state.getAllSupplierReducer,
  getSubModulesByRoleIdReducer: state.getSubModulesByRoleIdReducer,
  getDppDocumentsImageReducer: state.getDppDocumentsImageReducer,
});

const mapDispatchToProps = (dispatch) => ({
  getSubModulesByRoleId: (roleId, jwtToken) =>
    dispatch(getSubModulesByRoleId(roleId, jwtToken)),
  getAllSupplierInformation: (jwtToken) =>
    dispatch(getAllSupplierInformation(jwtToken)),
  createSupplierInformation: (payload, jwtToken) =>
    dispatch(createSupplierInformation(payload, jwtToken)),
  editSupplierInformation: (payload, jwtToken) =>
    dispatch(editSupplierInformation(payload, jwtToken)),
  deleteSupplierInformation: (id, udBy, jwtToken) =>
    dispatch(deleteSupplierInformation(id, udBy, jwtToken)),
  getDppDocumentsImage: (moduleName, type, name, jwtToken) =>
    dispatch(getDppDocumentsImage(moduleName, type, name, jwtToken)),
  uploadCsvForSupplierInformation: (payload, jwtToken) =>
    dispatch(uploadCsvForSupplierInformation(payload, jwtToken)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(SupplierInformation);
